import { render, staticRenderFns } from "./CommonRegisterFooter.vue?vue&type=template&id=dd7c8b84&scoped=true&"
import script from "./CommonRegisterFooter.vue?vue&type=script&lang=js&"
export * from "./CommonRegisterFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7c8b84",
  null
  
)

export default component.exports